export default __webpack_public_path__ + "static/media/noirnoir-divineswelling-cover.0f840a54.jpg";